'use client'

import { FormattedMessage } from '@b-stock/fe-core/bstock-react'

import { CATEGORIES, categoryListingsUrl } from './content'
import {
  CategoryPhoto,
  Inner,
  Section,
  SectionTitle,
  Tile,
  TileGrid,
  TileMeta,
  TileName,
} from './ui'

export default function BrowseByCategory() {
  return (
    <Section data-testid="logged-out-browse-by-category">
      <Inner>
        <SectionTitle>
          <FormattedMessage id="LoggedOutHomepage.browseByCategory.title" />
        </SectionTitle>
        <TileGrid $phoneColumns={2}>
          {CATEGORIES.map((category) => (
            <li key={category.key}>
              <Tile href={categoryListingsUrl(category.searchCategories)}>
                <CategoryPhoto
                  src={category.photo}
                  alt=""
                  width={800}
                  height={451}
                  sizes="(min-width: 90rem) 256px, (min-width: 80rem) calc((100vw - 10rem) / 5), (min-width: 48rem) calc((100vw - 8rem) / 3), calc((100vw - 4rem) / 2)"
                />
                <TileName>
                  <FormattedMessage
                    id={`LoggedOutHomepage.browseByCategory.tiles.${category.key}.name`}
                  />
                </TileName>
                <TileMeta>
                  <FormattedMessage
                    id="LoggedOutHomepage.browseByCategory.liveListings"
                    values={{ count: category.listings }}
                  />
                </TileMeta>
              </Tile>
            </li>
          ))}
        </TileGrid>
      </Inner>
    </Section>
  )
}
